import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import edmsHero from "../assets/Hero/EDMS.png"; // Replace with your hero image
import edmsImage from "../assets/Hero/edms-hero.png"; // Replace with your EDMS image
import "../assets/css/edmsPage.css";

// Register the ScrollTrigger plugin
gsap.registerPlugin(ScrollTrigger);

// JSON data for headings and paragraphs
const edmsData = {
  hero: {
    title: "Electronic Document Management Systems (EDMS)",
    subtitle: "Streamline Your Document Workflow with Advanced EDMS Solutions",
  },
  introduction: {
    heading: "Why EDMS Matters",
    paragraphs: [
      "Electronic Document Management Systems (EDMS) help businesses organize, store, and manage documents efficiently, reducing paperwork and improving productivity.",
      "Our EDMS solutions are designed to provide secure, scalable, and user-friendly document management for businesses of all sizes.",
    ],
  },
  cta: {
    heading: "Ready to Optimize Your Document Management?",
    text: "Contact us today to learn more about our EDMS Solutions and how we can help your business thrive.",
  },
};

export const EDMSPage = ({ data }) => {
  const edmsRef = useRef(null);
  const navigate = useNavigate(); // Initialize useNavigate

  useEffect(() => {
    const elements = edmsRef.current.querySelectorAll(".edms-animate");

    gsap.fromTo(
      elements,
      { y: 100, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 1.0,
        ease: "power3.out",
        stagger: 0.2,
        scrollTrigger: {
          trigger: edmsRef.current,
          start: "top 80%",
          toggleActions: "play none none reset",
        },
      }
    );
  }, []);

  // Function to handle navigation
  const handleContactClick = () => {
    navigate("/contact"); // Navigate to the contact page
  };

  return (
    <div id="edms-page" ref={edmsRef}>
      {/* Hero Section */}
      <div
        className="edms-hero-section"
        style={{ backgroundImage: `url(${edmsHero})` }}
      >
        <h1 className="edms-animate">{edmsData.hero.title}</h1>
        <p className="edms-animate">{edmsData.hero.subtitle}</p>
      </div>

      {/* Introduction Section */}
      <div className="container edms-introduction">
        <div className="row">
          <div className="col-md-6">
            <h2 className="edms-animate">{edmsData.introduction.heading}</h2>
            {edmsData.introduction.paragraphs.map((paragraph, index) => (
              <p key={index} className="edms-animate">
                {paragraph}
              </p>
            ))}
          </div>
          <div className="col-md-6 edms-image-container">
            <img
              src={edmsImage}
              className="img-fluid edms-animate"
              alt="Electronic Document Management Systems (EDMS)"
            />
          </div>
        </div>
      </div>

      {/* Call to Action Section */}
      {/* <div className="container edms-cta">
        <h2 className="edms-animate">{edmsData.cta.heading}</h2>
        <p className="edms-animate">{edmsData.cta.text}</p>
        <button
          className="btn btn-primary edms-animate"
          onClick={handleContactClick} // Add onClick handler
        >
          Contact Us
        </button>
      </div> */}
    </div>
  );
};